ScoreTrekBattle.Tournament.Preset = ScoreTrekBattle.Tournament.Preset || {};

ScoreTrekBattle.Tournament.Preset.Edit = (function() {
    var _this, STATUS, CONFIG, PRESET_VERSION_HISTORY, SHOW_NOTICE;

    SHOW_NOTICE = {};

    PRESET_VERSION_HISTORY = [
        {
            version: '',
            update: (preset) => {
                preset.version = '1.0';
            }
        },
        {
            version: '1.0',
            update: (preset) => {
                preset.preset.playerType = 'single';
                preset.version = '1.1';
            }
        },
        {
            version: '1.1',
            update: (preset) => {
                preset.version = '1.2';
                if (preset.preset.groupQualify === 'first') {
                    preset.preset.groupQualify = 1;
                } else if (preset.preset.groupQualify === 'firstSecond') {
                    preset.preset.groupQualify = 2;
                }
            }
        },
        {
            version: '1.2',
            update: (preset) => {
                preset.version = '1.3';
                if (preset.koSystem !== 'no') {
                    preset.preset.koQualify = 0;
                }
            }
        },
        {
            version: '1.3',
            update: (preset) => {
                preset.version = '1.4';

                preset.preset.hasKoQualify = (preset.preset.koSystem === 'no') ? null : ((preset.qualificantsCount > 0) ? 'yes' : 'no');
                preset.preset.koQualify = (preset.preset.hasKoQualify === null) ? null : ((preset.qualificantsCount > 0) ? preset.qualificantsCount : null);
            }
        },
        {
            version: '1.4',
            update: (preset) => {
                preset.version = '1.5';

                preset.preset.teamSize = null;
                preset.preset.teamDoubles = null;
            }
        },
        {
            version: '1.5',
            update: (preset) => {
                preset.version = '1.6';

                if (!preset.preset || !preset.preset.rounds || !preset.preset.rounds.items) {
                    return;
                }

                preset.preset.rounds.items.forEach(round => {
                    round.rotation = {};

                    if (round.gameType === 'gameMulti') {
                        SHOW_NOTICE.multiBallUpdate = true;

                        CONFIG.ROTATION_GAMES.forEach(gameType => {
                            let rotation;

                            rotation = {
                                active: true,
                                target: round.gameTarget,
                                games: []
                            };

                            for (let i = 1; i < round.gameTarget*2; i++) {
                                rotation.games.push(gameType);
                            }

                            round.rotation[gameType] = rotation;
                        });
                    }
                });
            }
        },
        {
            version: '1.6',
            update: (preset) => {
            }
        }
    ];

    CONFIG = {
        PRESET_VERSION: PRESET_VERSION_HISTORY[PRESET_VERSION_HISTORY.length - 1].version,
        PERSONS: {
            MAX: 1024
        },
        ALL: {
            MAX: 50
        },
        SPLIT: {
            MIN: 4
        },
        CHOICE_EDIT: {
            playerLimit: {
                MIN: 4,
                MAX: 128
            },
            groupCount: {
                MIN: 2,
                MAX: 80
            }
        },
        GROUP: { // limits of players per group
            MIN: 3,
            MAX: 12
        },
        GROUP_PHASE: {
            MIN: 6
        },
        DOUBLE_KO: {
            MIN: 4
        },
        GAMES: [
            'game08',
            'game09',
            'game10',
            'gameMulti',
            'game14',
            'gameOnePocket',
            'gameBankPool',
            'gameHeyball',
            'gameCarom',
            'gameSnooker'
        ],
        GAMES_DEFAULT_TARGETS: {
            'game08': 4,
            'game09': 4,
            'game10': 4,
            'gameMulti': 4,
            'game14': 100,
            'gameOnePocket': 8,
            'gameBankPool': 5,
            'gameHeyball': 5,
            'gameCarom': 100
        },
        MULTIBALL_GAMES: [
            'gameMulti',
            'game08',
            'game09',
            'game10'
        ],
        ROTATION_GAMES: [
            'game08',
            'game09',
            'game10'
        ],
        ALTERNATING_BREAK_GAMES: [
            'gameMulti',
            'game08',
            'game09',
            'game10',
            'gameOnePocket',
            'gameBankPool',
            'gameHeyball'
        ],
        TAKE_LIMIT_GAMES: [
            'game14',
            'gameCarom'
        ]
    };

    function resetStatus() {
        STATUS = {
            active: false,
            isInline: false,
            viewHandler: null,
            viewDialog: null,
            loadedPreset: null,
            isReadOnly: false,
            isUsedRunning: false,
            returnType: null,
            returnId: null,
            view: null,
            $view: null,
            choices: null,
            rounds: {}
        };
    }
    resetStatus();

    function onInline() {
        return new Promise(resolve => {
            STATUS.isInline = true;
            STATUS.viewHandler = {
                onShow: function(dialog) {
                    STATUS.viewDialog = dialog;

                    showNotices();

                    dialog.beforeClose(() => {
                        // TODO return false on unsaved changes
                        return true;
                    });
                }
            }
            resolve(STATUS.viewHandler);
        });
    }

    function onViewRenderCreate(returnType, returnId) {
        STATUS.loadedPreset = null;
        STATUS.returnType = returnType || null;
        STATUS.returnId = returnId || null;
        cacheRounds(null);
        return onViewRender();
    }

    function onViewRenderEdit(presetId, returnType, returnId) {
        if (presetId === 'null') {
            return onViewRenderCreate(returnType, returnId);
        }

        STATUS.loadedPreset = null;
        STATUS.returnType = returnType || null;
        STATUS.returnId = returnId || null;
        cacheRounds(null);

        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Preset.Edit.onViewRenderEdit', true);
            Api.request('/battle/tournament/preset/load', {id: presetId}).then(result => {
                STATUS.loadedPreset = result.preset;
                STATUS.isUsedRunning = result.preset.isUsedRunning;
                STATUS.isReadOnly = result.isReadOnly;
                SHOW_NOTICE.multiBallUpdate = false;
                autoUpdatePresetVersion(STATUS.loadedPreset);
                showNotices(); 
                onViewRender().then($view => {
                    resolve($view);
                });
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Preset.Edit.onViewRenderEdit', false);
            });
        });
    }

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu('/tournament/create');
            getGameChoicesHtml('tournament/create/gameChoice', CONFIG.GAMES).then(gameChoicesHtml => {
                var buttonText, isReadOnly;
                buttonText = STATUS.loadedPreset ? __i18n('button/savePreset') : __i18n('button/addPreset');
                isReadOnly = STATUS.isReadOnly || STATUS.isUsedRunning;
                ScoreTrekBattle.Template.render('tournament/preset/edit', {
                    introTitle: __i18n(`tournament/create/wizard/intro/${STATUS.loadedPreset ? (isReadOnly ? 'view' : 'edit') : 'create'}/title`, {button: buttonText}),
                    introText: __i18n(`tournament/create/wizard/intro/${STATUS.loadedPreset ? (isReadOnly ? 'view' : 'edit') : 'create'}/text`, {button: buttonText}),
                    gameChoices: gameChoicesHtml,
                    buttonText: buttonText
                }).then(view => {
                    STATUS.active = true;
                    STATUS.view = view;
                    STATUS.$view = view.$view;
                    STATUS.$view.toggleClass('isReadOnly', isReadOnly);
                    STATUS.$view.toggleClass('allowNameEdit', !STATUS.isReadOnly && STATUS.isUsedRunning);
                    STATUS.$view.find('[data-id="presetIsUsedRunningInfo"]').css('display', STATUS.isUsedRunning ? '' : 'none');

                    if (!STATUS.loadedPreset || !STATUS.loadedPreset.isOfficial) {
                        STATUS.$view.find('[data-ref-mode="official"]').hide();
                    }

                    // STATUS.view.controls.officialScheme.set(STATUS.loadedPreset.config ? STATUS.loadedPreset.config.officialScheme : '');

                    setPresetName();
                    resetChoices();
                    resolve(STATUS.$view);
                });
            });
        });
    }

    function getGameChoicesHtml(templateName, gameTypes) {
        return new Promise(function(resolve) {
            var promises;

            promises = [];

            gameTypes.forEach(gameType => {
                promises.push(ScoreTrekBattle.Template.render(templateName, {gameType: gameType}));
            });

            Promise.all(promises).then(views => {
                resolve(views.map(view => view.$view.get(0).outerHTML).join(''));
            }).catch(error => {
                console.warn(error);
                resolve('');
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            STATUS.$view.find('[data-choice]').on('click', function(event) {
                event.stopPropagation();
                handleChoiceClick($(this));
            });
            STATUS.$view.find('[data-choice] [data-id="edit"]').on('click', function(event) {
                var $choice;
                event.stopPropagation();
                $choice = $(this).closest('[data-choice]');
                handleChoiceEdit($choice).then(() => {
                    handleChoiceClick($choice, true);
                }).catch(ignore => {});
            });
            resetChoices();
            if (STATUS.loadedPreset) {
                initEditableChoices(STATUS.loadedPreset.preset);
                setChoices(STATUS.loadedPreset.preset, JSON.parse(JSON.stringify(STATUS.loadedPreset.preset.rounds)));
            }
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function onCheckAccess() {
        return ScoreTrekBattle.Session.isBattleManager();
    }

    function showNotices() {
        if (SHOW_NOTICE.multiBallUpdate) {
            chmDialog.info(
                __i18n('tournament/preset/notice/multiBallUpdate/text'),
                __i18n('tournament/preset/notice/multiBallUpdate/title'),
                __i18n('button/gotIt')
            );
        }
    }

    function initEditableChoices(choices) {
        if (STATUS.$view.find(`[data-step="playerLimit"] [data-choice="${choices.playerLimit}"]`).length === 0) {
            STATUS.$view.find('[data-step="playerLimit"] [data-choice][data-editable="yes"]').attr('data-choice', choices.playerLimit);
        }
    }

    function handleChoiceEdit($choice) {
        return new Promise((resolve, reject) => {
            var stepName, valueMinMax;

            stepName = $choice.closest('[data-step]').attr('data-step');

            if (!CONFIG.CHOICE_EDIT.hasOwnProperty(stepName)) {
                reject();
                return;
            }

            valueMinMax = CONFIG.CHOICE_EDIT[stepName];

            chmDialog.prompt({
                title: __i18n(`dialog/tournamentPreset/edit/${stepName}/title`),
                prompt: __i18n(`dialog/tournamentPreset/edit/${stepName}/prompt`, valueMinMax),
                value: $choice.attr('data-choice')
            }).then(value => {
                var isOutOfRange;

                if (value === null) {
                    return reject();
                }

                isOutOfRange = false;

                value = parseInt(value, 10);
                if (isNaN(value) || (value < valueMinMax.MIN)) {
                    isOutOfRange = true;
                    value = valueMinMax.MIN;
                }
                if (value > valueMinMax.MAX) {
                    isOutOfRange = true;
                    value = valueMinMax.MAX;
                }

                isOutOfRange = isOutOfRange  && ($choice.attr('data-selected') !== 'yes');

                if (isOutOfRange) {
                    $choice.attr('data-choice', 0);
                } else {
                    $choice.attr('data-choice', value);
                }

                updateChoiceLabels(stepName, STATUS.choices);

                if (isOutOfRange) {
                    reject();
                } else {
                    resolve();
                }
            }).catch(reject);
        });
    }

    function handleChoiceClick($choice, force) {
        var isSelected, isEditable, isZero, choices, choiceValue, stepName, isModified;

        choiceValue = $choice.attr('data-choice');
        isEditable = ($choice.attr('data-editable') === 'yes');
        isZero = (parseInt(choiceValue, 10) === 0);

        $step = $choice.closest('[data-step]');

        if (isEditable && isZero) {
            handleChoiceEdit($choice).then(() => {
                handleChoiceClick($choice, true);
            }).catch(ignore => {});
            return;
        }

        if ($step.find(`[data-choice="${choiceValue}"]`).length > 1) {
            $step.find('[data-choice][data-editable="yes"]').attr('data-choice', 0);
            handleChoiceClick($step.find(`[data-choice="${choiceValue}"]`).first(), true);
            return;
        }

        isSelected = true;

        choices = getChoices();

        $step.find('[data-choice]').attr('data-selected', 'no');
        $choice.attr('data-selected', isSelected ? 'yes' : 'no');

        stepName = $step.attr('data-step');

        isModified = force || (choices[stepName] !== choiceValue);

        if (!isModified) {
            return;
        }

        choices[stepName] = choiceValue;

        updateCachedRounds(choices);
        setChoices(choices);

        setTimeout(() => {
            let $nextStep, $nextVisibleChoices;
            $nextStep = $step;
            while($nextStep.length > 0) {
                $nextStep = $nextStep.next();
                if ($nextStep.attr('data-visible') === 'yes') {
                    break;
                }
            }
            if ($nextStep.length > 0) {
                $nextVisibleChoices = $nextStep.find('[data-choice]:not([data-visible="no"])');

                if ($nextVisibleChoices.length === 1) {
                    handleChoiceClick($nextVisibleChoices.first());
                    return;
                }

                AnimationHandler.scrollIntoView($nextStep, true);
            }
        }, 100);
    }

    function autoUpdatePresetVersion(preset) {
        if (!preset) {
            return;
        }
        PRESET_VERSION_HISTORY.forEach(historyItem => {
            if (historyItem.version === CONFIG.PRESET_VERSION) {
                return;
            }
            if (preset.version === historyItem.version) {
                historyItem.update(preset);
                console.log(`Update preset version: ${historyItem.version} >>> ${preset.version}`);
            }
        });
    }

    function resetChoices() {
        STATUS.$view.find('[data-step]:not(:first-child)').attr('data-visible', 'no');
        STATUS.$view.find('[data-choice]').attr('data-selected', 'no');
        STATUS.$view.find('[data-step="gameType"] [data-choice]').attr('data-visible', 'no');
        getAvailableGameTypes().forEach(gameType => {
            STATUS.$view.find(`[data-step="gameType"] [data-choice="${gameType}"]`).attr('data-visible', 'yes');
        });
        STATUS.$view.find('[data-step]').first().slideDown();
    }

    function setChoices(choices, rounds) {
        choices = validateChoices(choices);
        renderChoices(choices);
        choices = updateChoices(choices);
        choices = validateChoices(choices);
        renderChoices(choices);
        applyChoices(choices);
        if (STATUS.$view.find('[data-step="rounds"]').attr('data-visible') === 'yes') {
            STATUS.$view.find('[data-step="checkout"]').attr('data-visible', 'yes');
            choices.rounds = rounds || getRounds(choices, countGamesAndPlayers(choices));
            if (rounds) {
                cacheRounds(rounds);
            }
            renderRounds(choices.rounds, choices.gameType);
        } else {
            choices.rounds = null;
        }

        STATUS.choices = (STATUS.$view.find('[data-step="checkout"]').attr('data-visible') === 'yes') ? choices : null;
    }

    function getChoices() {
        var choices;
        choices = {};
        STATUS.$view.find('[data-step]').get().forEach(step => {
            var selected;
            selected = step.querySelector('[data-choice][data-selected="yes"]');
            choices[step.dataset.step] = selected ? selected.dataset.choice : null;
        });
        choices.rounds = null;

        return choices;
    }

    function validateChoices(choices) {
        if (!allowAlternatingBreak(choices.gameType)) {
            choices.alternatingBreak = null;
        }

        if (!choices.gameType) {
            choices.playerLimit = null;
        }

        if (!choices.playerType) {
            choices.teamSize = null;
        }

        if (choices.playerType && (choices.playerType !== 'team')) {
            choices.teamSize = null;
            choices.teamDoubles = null;
        }

        if (!choices.teamSize) {
            choices.teamDoubles = null;
        }

        if ((!choices.teamDoubles && (choices.teamDoubles !== 0))  && (choices.playerType === 'team')) {
            choices.playerLimit = null;
        }

        if (!choices.playerLimit) {
            choices.groupPhase = null;
        }

        if (
            (!choices.groupPhase)
            ||
            (choices.groupPhase === 'no')
        ) {
            choices.groupCount = null;
            choices.groupQualify = null;
        }

        if ((choices.groupPhase === 'yes') && !choices.groupCount) {
            choices.groupQualify = null;
        }

        if ((choices.groupPhase === 'yes') && !choices.groupQualify) {
            choices.koSystem = null;
        }

        if (!choices.groupPhase) {
            choices.koSystem = null;
        }

        if (choices.koSystem !== 'double') {
            choices.koSystemSingle = null;
        }

        if (
            (!choices.koSystem)
            ||
            (choices.koSystem === 'no')
            ||
            ((choices.koSystem === 'double') && !choices.koSystemSingle)
        ) {
            choices.hasKoQualify = null;
        }

        if (
            (!choices.hasKoQualify)
            ||
            (choices.hasKoQualify === 'no')
        ) {
            choices.koQualify = null;
        }

        if (
            (!choices.koSystem)
            ||
            ((choices.koSystem === 'double') && !choices.koSystemSingle)
            ||
            (!choices.hasKoQualify && (choices.koSystem !== 'no'))
            ||
            (!choices.koQualify && (choices.hasKoQualify === 'yes'))
        ) {
            choices.alternatingBreak = null;
        }

        ['teamSize', 'teamDoubles', 'playerLimit', 'groupCount', 'groupQualify', 'koSystemSingle', 'koQualify'].forEach(choice => {
            if (choices[choice] !== null) {
                choices[choice] = parseInt(choices[choice], 10);
            }
        });

        return choices;
    }

    function allowAlternatingBreak(gameType) {
        return (CONFIG.ALTERNATING_BREAK_GAMES.indexOf(gameType) >= 0);
    }

    function allowTakeLimit(gameType) {
        return (CONFIG.TAKE_LIMIT_GAMES.indexOf(gameType) >= 0);
    }

    function allowGameTarget(gameType) {
        return (CONFIG.GAMES_DEFAULT_TARGETS.hasOwnProperty(gameType));
    }

    function updateChoices(choices) {
        Object.keys(choices).forEach(step => {
            if (STATUS.$view.find(`[data-step="${step}"] [data-choice="${choices[step]}"]`).attr('data-visible') === 'no') {
                choices[step] = null;
            }
        });
        return choices;
    }

    function applyChoices(choices) {
        var nextStep;
        nextStep = 'gameType';
        STATUS.$view.find(`[data-step] [data-choice]`).attr('data-selected', 'no');
        Object.keys(choices).forEach(step => {
            var isVisible, $choice;
            isVisible = (choices[step] !== null);
            STATUS.$view.find(`[data-step="${step}"]:not(:first-child)`).attr('data-visible', isVisible ? 'yes' : 'no');
            if (isVisible) {
                $choice = STATUS.$view.find(`[data-step="${step}"] [data-choice="${choices[step]}"]`);
                if ($choice.attr('data-visible') !== 'no') {
                    $choice.attr('data-selected', 'yes');
                }
            } else if (nextStep === 'gameType') {
                nextStep = step;
            }
        });
        if ((nextStep === 'teamSize') && choices.teamSize) {
            nextStep = 'teamDoubles';
        }
        if ((nextStep === 'teamSize') && choices.playerType && (choices.playerType !== 'team')) {
            nextStep = 'playerLimit';
        }
        if ((nextStep === 'teamDoubles') && (choices.teamDoubles || (choices.teamDoubles === 0))) {
            nextStep = 'playerLimit';
        }
        if ((nextStep === 'teamDoubles') && choices.playerType && (choices.playerType !== 'team')) {
            nextStep = 'playerLimit';
        }
        if ((nextStep === 'playerLimit') && choices.playerLimit) {
            nextStep = 'groupPhase';
        }
        if ((nextStep === 'groupPhase') && choices.groupPhase) {
            nextStep = 'groupCount';
        }
        if ((nextStep === 'groupCount') && (choices.groupPhase === 'no')) {
            nextStep = choices.koSystem ? 'koSystemSingle' : 'koSystem';
        }
        if ((nextStep === 'groupCount') && choices.groupCount) {
            nextStep = 'groupQualify';
        }
        if ((nextStep === 'groupQualify') && choices.groupQualify) {
            nextStep = 'koSystem';
        }
        if ((nextStep === 'koSystem') && choices.koSystem) {
            nextStep = choices.koSystem ? 'koSystemSingle' : 'koSystem';
        }
        if ((nextStep === 'koSystemSingle') && ((choices.koSystem !== 'double') || choices.koSystemSingle)) {
            nextStep = 'hasKoQualify';
        }
        if ((nextStep === 'hasKoQualify') && (choices.hasKoQualify || (choices.koSystem === 'no'))) {
            nextStep = 'koQualify';
        }
        if ((nextStep === 'koQualify') && (choices.koQualify || (choices.hasKoQualify !== 'yes'))) {
            nextStep = 'alternatingBreak';
        }
        if ((nextStep === 'alternatingBreak') && (choices.alternatingBreak || !allowAlternatingBreak(choices.gameType))) {
            nextStep = 'rounds';
        }
        if (!nextStep) {
            nextStep = 'rounds';
        }
        STATUS.$view.find(`[data-step="${nextStep}"],[data-related-step="${nextStep}"]`).attr('data-visible', 'yes');
    }
        
    function renderChoices(choices) {
        var count;

        count = countGamesAndPlayers(choices);

        if (choices.playerLimit) {
            STATUS.$view.find('[data-step="groupPhase"] [data-choice="yes"]').attr('data-visible', (count.playersTotal >= CONFIG.GROUP_PHASE.MIN) ? 'yes' : 'no');
            STATUS.$view.find('[data-step="koSystem"] [data-choice="double"]').attr('data-visible', (count.playersTotal >= CONFIG.DOUBLE_KO.MIN) ? 'yes' : 'no');
            STATUS.$view.find('[data-step="groupCount"] [data-choice]').get().forEach(groupCountChoice => {
                let choiceValue, choiceCount;
                choiceValue = parseInt(groupCountChoice.dataset.choice, 10);
                choiceCount = calculateGroup(count.playersTotal, choiceValue);
                groupCountChoice.dataset.visible = ((choiceCount.playersPerGroupMin < CONFIG.GROUP.MIN) || (choiceCount.playersPerGroupMax > CONFIG.GROUP.MAX)) ? 'no' : 'yes';
                groupCountChoice.querySelector('[data-id="label"]').innerHTML = __i18n('tournament/create/choice/groupCount/label', {playersCount: choiceCount.playersPerGroupText, playerType: __i18n(`playerType/pluralDative/${choices.playerType || 'single'}`)});
                groupCountChoice.querySelector('[data-id="details"]').innerHTML = __i18n('tournament/create/choice/groupCount/details', {gameCountGroup: choiceCount.gamesPerGroupText, gameCountPhase: choiceCount.groupGamesTotal});
            });
        }

        if (choices.playerType) {
            updateChoiceLabels('playerLimit', choices);
            updateChoiceLabels('teamSize', choices);
        }

        STATUS.$view.find('[data-step="koSystem"] [data-choice="single"] [data-id="details"]').html(
            __i18n('tournament/create/choice/koSystem/single/details', {starterCount: count.koPlayersTotalBase2})
        );

        STATUS.$view.find('[data-step="koSystem"] [data-choice="double"] [data-id="details"]').html(
            __i18n('tournament/create/choice/koSystem/double/details', {starterCount: count.koPlayersTotalBase2})
        );

        STATUS.$view.find('[data-step="koSystem"] [data-choice="split"]').attr('data-visible', ((choices.groupPhase === 'yes') && (count.koPlayersSplitBase2 >= CONFIG.SPLIT.MIN)) ? 'yes' : 'no').find('[data-id="details"]').html(
            __i18n('tournament/create/choice/koSystem/split/details', {starterCount: count.koPlayersSplitBase2})
        );

        STATUS.$view.find('[data-step="koSystem"] [data-choice="all"]').attr('data-visible', ((choices.groupPhase === 'yes') || (count.playersTotal > CONFIG.ALL.MAX)) ? 'no' : 'yes').find('[data-id="details"]').html(
            __i18n('tournament/create/choice/koSystem/all/details', {gameCount: count.gamesOneOnOneTotal})
        );

        if (choices.groupCount) {
            STATUS.$view.find('[data-step="groupQualify"] [data-choice]').get().forEach(groupQualifyChoice => {
                let choiceValue;
                choiceValue = parseInt(groupQualifyChoice.dataset.choice, 10);
                groupQualifyChoice.dataset.visible = (count.groupCount.playersPerGroupMin > choiceValue) ? 'yes' : 'no';
                groupQualifyChoice.querySelector('[data-id="label"]').innerHTML = __i18n(`tournament/create/choice/groupQualify/label/${choiceValue}`);
                groupQualifyChoice.querySelector('[data-id="details"]').innerHTML = __i18n(`tournament/create/choice/groupQualify/details`, {playersCount: count.groupsTotal * choiceValue, playerType: __i18n(`playerType/plural/${choices.playerType || 'single'}`)});
                if (choiceValue < 4) {
                    groupQualifyChoice.querySelector('[data-id="icon"]').innerHTML = __i18n(`tournament/create/choice/groupQualify/icon/${choiceValue}`);
                }
            });
        }

        if (choices.groupQualify) {
            STATUS.$view.find('[data-step="koSystem"] [data-choice="double"]').attr('data-visible', (count.groupQualifyTotal >= CONFIG.DOUBLE_KO.MIN) ? 'yes' : 'no');
            STATUS.$view.find('[data-step="koSystem"] [data-choice="no"] [data-id="details"]').html(__i18n('tournament/create/choice/koSystem/no/details', {personsCount: (count.groupQualifyTotal * getPersonsFactor(choices))}));
        }

        STATUS.$view.find('[data-step="koSystem"] [data-choice="no"]').attr('data-visible', (choices.groupPhase === 'no') ? 'no' : 'yes');

        [16,8,4].forEach(koSystemSingleValue => {
            STATUS.$view.find(`[data-step="koSystemSingle"] [data-choice="${koSystemSingleValue}"]`).attr('data-visible', (count.koPlayersTotal > koSystemSingleValue) ? 'yes' : 'no');
        });

        if (choices.teamSize) {
            STATUS.$view.find('[data-step="teamDoubles"] [data-choice]').get().forEach(teamDoublesChoice => {
                let teamDoubles, singleMatchesCount;
                teamDoubles = parseInt(teamDoublesChoice.dataset.choice, 10);
                singleMatchesCount = (choices.teamSize - (teamDoubles * 2));
                matchesCount = singleMatchesCount + teamDoubles;
                teamDoublesChoice.dataset.visible = ((teamDoubles * 2) <= choices.teamSize) ? 'yes' : 'no';
                teamDoublesChoice.querySelector('[data-id="label"]').innerHTML = __i18n(`tournament/create/choice/teamDoubles/${(teamDoubles === 1) ? 'single' : 'multi'}`);
                teamDoublesChoice.querySelector('[data-id="details"]').innerHTML = __i18n(`tournament/create/choice/teamDoubles/matches`, {matchesCount: matchesCount, singleMatchesCount: singleMatchesCount, doubleMatchesCount: teamDoubles});
            });
        }

        if (choices.playerType && choices.teamSize && (choices.teamDoubles || (choices.teamDoubles === 0)) && choices.koSystem) {
            STATUS.$view.find('[data-step="hasKoQualify"] [data-choice="yes"]').attr('data-visible', (choices.koSystem === 'split') ? 'no' : 'yes');

            STATUS.$view.find('[data-step="koQualify"] [data-choice]').get().forEach(koQualifyChoice => {
                var koQualify, koQualifyType, isAvailable, maxPosition, placeholders, isDoubleKnockoutChoice;

                koQualify = parseInt(koQualifyChoice.dataset.choice, 10);
                koQualifyType = (koQualify === 0) ? 'none' : ((koQualify === 1) ? 'single' : 'multi');
                isDoubleKnockoutChoice = (koQualify > 4) && ((koQualify % 3) === 0);
                isDoubleKnockout = (choices.koSystem === 'double') && (choices.koSystemSingle < koQualify);
                isAvailable = (koQualify === 0) || ((choices.koSystem !== 'split') && (count.koPlayersTotalBase2 > koQualify));

                maxPosition = koQualify;

                placeholders = {
                    koQualify: koQualify,
                    personsCount: koQualify * getPersonsFactor(choices),
                    maxPosition: maxPosition
                };

                koQualifyChoice.dataset.visible = (!isAvailable || (isDoubleKnockoutChoice && !isDoubleKnockout)) ? 'no' : 'yes';
                koQualifyChoice.querySelector('[data-id="icon"]').innerHTML = __i18n(`tournament/create/choice/koQualify/${koQualifyType}/icon`, placeholders);
                koQualifyChoice.querySelector('[data-id="label"]').innerHTML = __i18n(`tournament/create/choice/koQualify/${koQualifyType}/label`, placeholders);
                koQualifyChoice.querySelector('[data-id="details"]').innerHTML = __i18n(`tournament/create/choice/koQualify/${(placeholders.personsCount === 1) ? 'single' : 'multi'}/details`, placeholders);
            });
        }
    }

    function updateChoiceLabels(stepName, choices) {
        if (!choices) {
            choices = {};
        }

        if (stepName === 'playerLimit') {
            STATUS.$view.find('[data-step="playerLimit"] [data-choice]').get().forEach(playerLimitChoice => {
                var playerLimit, personsCount, teamSize;
                teamSize = getPersonsFactor(choices);
                playerLimit = parseInt(playerLimitChoice.dataset.choice, 10);
                personsCount = playerLimit * teamSize;
                playerLimitChoice.dataset.visible = (personsCount <= CONFIG.PERSONS.MAX) ? 'yes' : 'no';
                playerLimitChoice.querySelector('[data-id="icon"]').innerHTML = playerLimit;
                playerLimitChoice.querySelector('[data-id="label"]').innerHTML = (playerLimit === 0) ? __i18n('tournament/create/choice/playerLimit/custom') : __i18n('tournament/create/choice/playerLimit/label', {playerLimit: playerLimit, playerType: __i18n(`playerType/plural/${choices.playerType || 'single'}`)});
                playerLimitChoice.querySelector('[data-id="details"]').innerHTML = __i18n('tournament/create/choice/playerLimit/details', {personsCount: personsCount});
            });
        } else if (stepName === 'teamSize') {
            STATUS.$view.find('[data-step="teamSize"] [data-choice]').get().forEach(teamSizeChoice => {
                var teamSize;
                teamSize = parseInt(teamSizeChoice.dataset.choice, 10);
                teamSizeChoice.querySelector('[data-id="icon"]').innerHTML = teamSize;
                teamSizeChoice.querySelector('[data-id="label"]').innerHTML = __i18n('tournament/create/choice/teamSize/label', {teamSize: teamSize});
                teamSizeChoice.querySelector('[data-id="details"]').innerHTML = __i18n('tournament/create/choice/teamSize/details', {teamSize: teamSize});
            });
        }
    }

    function getAvailableGameTypes() {
        return CONFIG.GAMES.filter(gameType => {
            //TODO change available options for gameType depending on club tables
            return true;
        });
    }

    function getPersonsFactor(choices) {
        if (!choices) {
            return 1;
        }
        if (choices.playerType === 'team') {
            return choices.teamSize || 1;
        }
        return (choices.playerType === 'double') ? 2 : 1;
    }

    function cacheRounds(rounds) {
        STATUS.rounds = {};
        if (!rounds || !rounds.items) {
            return;
        }
        rounds.items.forEach(round => {
            STATUS.rounds[`${round.type}_${round.subType}_${round.round}`] = round;
        });
    }

    function updateCachedRounds(choices) {
        Object.values(STATUS.rounds).forEach(round => {
            // if (choices.gameType === 'gameMulti') {
            //     round.gameType = choices.gameType;
            // }
        });
    }

    function getRounds(choices, count) {
        let rounds, roundNumber, switchToSingle, singleMatchesCount, winnerSingleMatchesOffset, loserSingleMatchesOffset;

        function addRound(roundName, type, subType, gamesCount, details) {
            let round;
            round = {
                type: type,
                subType: subType,
                round: `${roundName}`,
                gamesCount: gamesCount,
                gameType: choices.gameType,
                gameTarget: allowGameTarget(choices.gameType) ? CONFIG.GAMES_DEFAULT_TARGETS[choices.gameType] : 0,
                takeLimit: allowTakeLimit(choices.gameType) ? 0 : 0,
                details: details
            };
            rounds.items.push(round);
            rounds.total.gamesCount += gamesCount;
        }

        rounds = {
            total: {
                gamesCount: 0
            },
            items: []
        };

        roundNumber = 0;
        switchToSingle = false;

        if (choices.groupPhase !== 'no') {
            roundNumber++;
            addRound(roundNumber, 'groupPhase', 'koSystemAll', count.groupCount.groupGamesTotal, {groupCount: count.groupCount});
        }

        switch (choices.koSystem) {
            case 'all':
                roundNumber++;
                addRound(roundNumber, 'koSystemAll', 'groupPhase', count.gamesOneOnOneTotal);
                break;
            case 'split':
                roundNumber++;
                addRound(`A ${roundNumber}`, 'partitionA', 'koSystemSplit', (count.koPlayersSplitBase2 - 2));
                roundNumber++;
                addRound(`B ${roundNumber}`, 'partitionB', 'koSystemSplit', (count.koPlayersSplitBase2 - 2));
                roundNumber++;
                addRound(roundNumber, 'finalA', 'koSystemSplit', 1);
                roundNumber++;
                addRound(roundNumber, 'finalB', 'koSystemSplit', 1);
                break;
            case 'single':
                roundNumber++;
                addRound(roundNumber, 'koSystemSingle', 'winnersRound', (count.koPlayersTotalBase2 - 2));
                roundNumber++;
                addRound(roundNumber, 'third', 'decider', 1);
                roundNumber++;
                addRound(roundNumber, 'final', 'koSystemSingle', 1);
                break;
            case 'double':
                switchToSingle = (count.koPlayersSingleTotal > 2);

                winnerSingleMatchesOffset = switchToSingle ? ((count.koPlayersSingleTotal / 2) - 1) : 0;
                loserSingleMatchesOffset = switchToSingle ? (count.koPlayersSingleTotal - 3) : 0;
                singleMatchesCount = switchToSingle ? (count.koPlayersSingleTotal - 2) : 0;

                roundNumber++;
                addRound(`${roundNumber}.a`, 'winnersRound', 'koSystemDouble', ((count.koPlayersTotalBase2 - 1) - winnerSingleMatchesOffset));
                addRound(`${roundNumber}.b`, 'losersRound', 'koSystemDouble', ((count.koPlayersTotalBase2 - 3) - loserSingleMatchesOffset));

                if (switchToSingle) {
                    roundNumber++;
                    addRound(roundNumber, 'koSystemSingle', 'winnersRound', singleMatchesCount);
                }

                if (switchToSingle) {
                    roundNumber++;
                    addRound(roundNumber, 'third', 'koSystemSingle', 1);
                    roundNumber++;
                    addRound(roundNumber, 'final', 'koSystemSingle', 1);
                } else {
                    roundNumber++;
                    addRound(roundNumber, 'smallFinal', switchToSingle ? 'koSystemSingle' : 'koSystemDouble', 1);
                    roundNumber++;
                    addRound(roundNumber, 'grandFinal', 'koSystemDouble', 1, {info: 'grandFinal'});
                }

                break;
            default:
                //no phase
        }

        return rounds;

    }    

    function renderRounds(rounds, gameType) {
        var $rounds;

        $rounds = STATUS.$view.find('[data-id="rounds"]').empty();

        STATUS.$view.find('[data-id="gamesTotal"]').html(__i18n('game/matches', {count: rounds.total.gamesCount}));

        getGameChoicesHtml('tournament/create/roundGameChoice', CONFIG.ROTATION_GAMES).then(rotationGameChoicesHtml => {
            ScoreTrekBattle.Template.render('tournament/create/round').then(roundView => {
                rounds.items.forEach(round => {
                    $rounds.append(
                        renderRound(roundView.$view.clone(), round, gameType, rotationGameChoicesHtml)
                    );
                });
            });
        });
    }

    function renderRound($round, round, gameType, rotationGameChoicesHtml) {
        var cachedRound, hasRotation;

        if (STATUS.rounds.hasOwnProperty(`${round.type}_${round.subType}_${round.round}`)) {
            cachedRound = STATUS.rounds[`${round.type}_${round.subType}_${round.round}`];
            round.gameType = (gameType === 'gameMulti') ? cachedRound.gameType : gameType;
            round.gameTarget = allowGameTarget(round.gameType) ? (cachedRound.gameTarget || CONFIG.GAMES_DEFAULT_TARGETS[round.gameType]) : 0;
            round.takeLimit = allowTakeLimit(round.gameType) ? cachedRound.takeLimit : 0;
            round.timeLimit = cachedRound.timeLimit || 0;
            round.rotation = cachedRound.rotation || {};
        } else {
            round.gameTarget = CONFIG.GAMES_DEFAULT_TARGETS[round.gameType];
            round.takeLimit = allowTakeLimit(round.gameType) ? 0 : 0;
            round.timeLimit = 0;
            round.rotation = {};
        }

        hasRotation = (gameType === 'gameMulti');

        $round.attr('data-round-type', round.type);
        $round.attr('data-round-subtype', round.subType);

        $round.find('[data-id="roundTitle"]').html(__i18n('tournament/create/choice/rounds/round', {round: round.round}));
        $round.find('[data-id="roundLabel"]').html(__i18n(`tournament/create/choice/rounds/type/${round.type}`, {playersCount: (round.gamesCount * 2)}));
        $round.find('[data-id="roundSubLabel"]').html(__i18n(`tournament/create/choice/rounds/type/${round.subType}`, {playersCount: (round.gamesCount * 2)}));
        $round.find('[data-id="roundDetails"]').html(__i18n(`tournament/create/choice/rounds/details/${(round.gamesCount === 1) ? 'single' : 'multi'}`, {gameCount: round.gamesCount}));

        if (round.details && round.details.info) {
            $round.find('[data-id="roundLabel"]').append(`<span class="info-popup" data-info-popup="tournament/create/choice/rounds/info/${round.details.info}"><i class="fa-solid fa-circle-info"></i></span>`);
        }

        $round.find('[data-id="roundGameTargetWrapper"]').css('display', allowGameTarget(gameType) || allowGameTarget(round.gameType) ? '' : 'none');
        chmPointsSelector($round.find('[data-id="roundGameTarget"]'), Math.min(1, round.gameTarget), 999).set(round.gameTarget).onChange(function() {
            round.gameTarget = this.get();
        });

        $round.find('[data-id="roundTakeLimitWrapper"]').css('display', (allowTakeLimit(gameType) || allowTakeLimit(round.gameType)) ? '' : 'none');
        chmPointsSelector($round.find('[data-id="roundTakeLimit"]'), 0).set(round.takeLimit).onChange(function() {
            round.takeLimit = this.get();
        });

        $round.find('[data-id="roundTimeLimitWrapper"]');
        chmPointsSelector($round.find('[data-id="roundTimeLimit"]'), 0, 300).set(round.timeLimit || 0).onChange(function() {
            round.timeLimit = this.get();
        });

        $round.find('[data-id="simpleGameType"]').css('display', hasRotation ? 'none' : '');
        $round.find('[data-id="advancedGameType"]').css('display', hasRotation ? '' : 'none');

        if (!hasRotation) {
            return $round;
        }

        renderAdvancedGameType(round, $round.find('[data-id="advancedGameType"]'), rotationGameChoicesHtml, function($gameTypeOptions) {
            let maxTarget;

            round.rotation = {};
            maxTarget = 0;

            $gameTypeOptions.each(function() {
                let rotation, isActive, target;

                isActive = !this.classList.contains('isDisabled');
                target = isActive ? parseInt(this.dataset.target) : 0;

                maxTarget = Math.max(maxTarget, target);

                rotation = {
                    active: isActive,
                    target: target,
                    games: []
                };

                $(this).find('[data-id="optionGameType"]').each(function() {
                    rotation.games.push(this.dataset.value);
                });

                round.rotation[this.dataset.gameType] = rotation;
            });

            round.gameTarget = maxTarget;
        });

        return $round;
    }

    function renderAdvancedGameType(round, $advancedGameType, gameChoicesHtml, onChange) {
        $advancedGameType.find('[data-game-type]').each(function() {
            let $option, $games, $toggle, $add, $remove, gameType;

            function updateView() {
                let count, isActive, target, $target;

                count = $games.children().length;
                target = Math.ceil(count / 2);

                $add.toggleClass('isDisabled', (count >= 99));
                $remove.toggleClass('isDisabled', (count <= 1));

                isActive = ($toggle.attr('data-is-active') === 'yes');

                $option.toggleClass('isDisabled', !isActive);
                $option.attr('data-target', target);

                $target = $option.find('[data-id="target"]');
                $target.text(target);

                onChange($option.parent().find('[data-id="rotationOption"]'));
            }

            $option = $(this);

            $toggle = $option.find('[data-id="toggle"]');
            $add = $option.find('[data-id="addGame"]');
            $remove = $option.find('[data-id="removeGame"]');
            $games = $option.find('[data-id="games"]');

            gameType = this.dataset.gameType;

            $option.find('[data-id="addGame"]').on('click', function() {
                let gamePromises, lastGameType;

                if ($option.hasClass('isAnimating')) {
                    return;
                }

                lastGameType = $games.children().last().find('[data-id="optionGameType"]').attr('data-value') || gameType;

                gamePromises = [
                    renderAdvancedGameTypeGame(lastGameType, gameChoicesHtml, () => {
                        updateView();
                    }),
                    renderAdvancedGameTypeGame(lastGameType, gameChoicesHtml, () => {
                        updateView();
                    })
                ];

                Promise.all(gamePromises).then($gamesToAdd => {
                    $gamesToAdd.filter(gameToAdd => {
                        return !!gameToAdd;
                    });

                    if ($gamesToAdd.length === 0) {
                        return;
                    }

                    $games.append($gamesToAdd);

                    $option.addClass('isAnimating');
                    $($gamesToAdd).hide().slideDown(300, function() {
                        $option.removeClass('isAnimating');
                        updateView();
                    });
                });
            });

            $option.find('[data-id="removeGame"]').on('click', function() {
                let games, $games;

                if ($option.hasClass('isAnimating')) {
                    return;
                }

                games = Array.from($option.find('[data-id="games"]').children());

                if (games.length <= 1) {
                    return;
                }

                $games = $().add(games.pop()).add(games.pop());

                $option.addClass('isAnimating');
                $games.slideUp(300, function() {
                    $games.remove();
                    $option.removeClass('isAnimating');
                    updateView();
                });
            });

            $option.find('[data-id="title"]').on('click', function() {
                let isActive, hasActiveToggle;

                isActive = ($toggle.attr('data-is-active') !== 'yes');

                $toggle.attr('data-is-active', isActive ? 'yes' : 'no');

                if (!isActive) {
                    hasActiveToggle = ($advancedGameType.find('[data-id="toggle"][data-is-active="yes"]').length > 0);

                    if (!hasActiveToggle) {
                        $toggle.attr('data-is-active', 'yes');
                        return;
                    }
                }

                updateView();
            });

            (function() {
                let roundGames, roundGamePromises, i;

                roundGames = round.rotation[gameType] ? round.rotation[gameType].games : [];

                $toggle.attr('data-is-active', (round.rotation[gameType] && (round.rotation[gameType].active === false)) ? 'no' : 'yes');

                if (roundGames.length === 0) {
                    for (i = 0; i < ((CONFIG.GAMES_DEFAULT_TARGETS[gameType] * 2) - 1); i++) {
                        roundGames.push(gameType);
                    }
                }

                roundGamePromises = [];

                roundGames.forEach(roundGameType => {
                    roundGamePromises.push(
                        renderAdvancedGameTypeGame(roundGameType, gameChoicesHtml, () => {
                            updateView();
                        })
                    );
                });

                Promise.all(roundGamePromises).then($roundGames => {
                    $roundGames.forEach(($roundGame, index) => {
                        let isFirst;

                        isFirst = (index === 0);

                        $games.append($roundGame);
                        $option.addClas

                        if (isFirst) {
                            $roundGame.find('[data-id="optionGameType"]').addClass('isDisabled');
                        }
                    });

                    updateView();
                });
            })();
        });
    }

    function renderAdvancedGameTypeGame(gameType, gameChoicesHtml, onUpdate) {
        return new Promise(resolve => {
            let $game;

            $game = $('<div>').addClass('rotation-option-game').attr('data-game-type', gameType).append(
                $([
                    `<div class="chmItemsSelector isSmall" data-id="optionGameType" data-value="">`,
                        `<div class="chmItemsSelector-button" data-change-value="prev">`,
                            `<i class="fas fa-chevron-left"></i>`,
                        `</div>`,
                        `<div class="chmItemsSelector-items" data-id="gameChoices">`,
                            gameChoicesHtml,
                        `</div>`,
                        `<div class="chmItemsSelector-button" data-change-value="next">`,
                            `<i class="fas fa-chevron-right"></i>`,
                        `</div>`,
                    `</div>`
                ].join(''))
            );

            chmItemsSelector($game.find('[data-id="optionGameType"]')).set(validateGameMultiType(gameType, true)).onChange(function() {
                $game.attr('data-game-type', this.get());
                onUpdate();
            });

            resolve($game);
        });
    }

    function countToString(countMin, countMax) {
        return (countMin === countMax) ? String(countMin) : `${countMin} / ${countMax}`;
    }

    function calculateGroup(playersCount, groupsCount) {
        var count;
        count = {};

        count.playersPerGroup = playersCount / groupsCount;
        count.playersPerGroupMin = Math.floor(count.playersPerGroup);
        count.playersPerGroupMax = Math.ceil(count.playersPerGroup);
        count.playersPerGroupText = countToString(count.playersPerGroupMin, count.playersPerGroupMax);

        count.gamesPerGroupMin = Numbers.calculateMatches(count.playersPerGroupMin);
        count.gamesPerGroupMax = Numbers.calculateMatches(count.playersPerGroupMax);
        count.gamesPerGroupText = countToString(count.gamesPerGroupMin, count.gamesPerGroupMax);

        count.groupsCountSmall = 0;
        count.groupsCountLarge = groupsCount;
        while ((count.groupsCountLarge > 0) && (((count.groupsCountLarge * count.playersPerGroupMax) + (count.groupsCountSmall * count.groupsCountSmall)) > playersCount)) {
            count.groupsCountSmall++;
            count.groupsCountLarge--;
        }

        count.groupGamesTotal = (count.groupsCountSmall * count.gamesPerGroupMin) + (count.groupsCountLarge * count.gamesPerGroupMax);

        return count;
    }

    function countGamesAndPlayers(choices) {
        var count, groupCount;
        count = {
            playersTotal: 0,
            groupsTotal: 0
        };

        if (choices.playerLimit) {
            count.playersTotal = choices.playerLimit;
            count.gamesOneOnOneTotal = Numbers.calculateMatches(count.playersTotal);
        }

        if (choices.groupCount) {
            count.groupsTotal = (choices.groupPhase === 'no') ? 0 : choices.groupCount;
        }

        if (count.groupsTotal > 0) {
            count.groupPlayersPerGroup = count.playersTotal / count.groupsTotal;
            groupCount = calculateGroup(count.playersTotal, count.groupsTotal);
            count.groupCount = groupCount;
        }

        if (choices.groupQualify) {
            count.groupQualifyTotal = count.groupsTotal * choices.groupQualify;
        }

        count.koPlayersTotal = ((count.groupQualifyTotal > 0) ? count.groupQualifyTotal : count.playersTotal);
        count.koPlayersTotalBase2 = Numbers.calculateNextBase2(count.koPlayersTotal);

        count.koPlayersSplit = Math.ceil(((count.groupQualifyTotal > 0) ? count.groupQualifyTotal : count.playersTotal) / 2);
        count.koPlayersSplitBase2 = Numbers.calculateNextBase2(count.koPlayersSplit);

        if (choices.koSystem === 'no') {
            count.koPlayersTotal = 0;
        }


        if (choices.koSystemSingle) {
            count.koPlayersSingleTotal = choices.koSystemSingle;
        }

        return count;
    }

    function cloneChoices() {
        var choices, isGameMulti;
        choices = JSON.parse(JSON.stringify(STATUS.choices));
        delete choices.checkout;

        isGameMulti = (choices.gameType === 'gameMulti');

        if (choices.rounds && choices.rounds.items) {
            choices.rounds.items.forEach(item => {
                if (!isGameMulti) {
                    delete item.rotation;
                    return;
                }

                item.gameType = 'gameMulti';
            });
        }

        return choices;
    }

    function generatePresetName() {
        return `${__i18n(`gameType/${STATUS.choices.gameType}`)} - ${STATUS.choices.playerLimit} ${__i18n(`game/participants`)}`;
    }

    function setPresetName(presetName, isDefaultName) {
        var $presetName;

        if (!presetName) {
            presetName = STATUS.loadedPreset ? STATUS.loadedPreset.name : __i18n(`tournament/create/wizard/name`);
            isDefaultName = !STATUS.loadedPreset;
        }

        $presetName = STATUS.$view.find('[data-id="presetName"]');

        $presetName.attr('data-is-default', isDefaultName ? 'yes' : 'no');

        $presetName[isDefaultName ? 'html' : 'text'](presetName);
    }

    function getPresetName() {
        return STATUS.$view.find('[data-id="presetName"]').text();
    }

    function inputPresetName() {
        return new Promise(function(resolve, reject) {
            var $presetName;
            $presetName = STATUS.$view.find('[data-id="presetName"]');

            if ($presetName.attr('data-is-default') === 'yes') {
                editPresetName(generatePresetName()).then(presetName => {
                    setPresetName(presetName, true);
                    resolve(presetName);
                }).catch(reject);
            } else {
                resolve(getPresetName());
            }

        });
    }

    function savePreset(presetId) {
        if (!validatePreset()) {
            return;
        }

        inputPresetName().then(presetName => {
            var presetData;

            presetData = {
                name: presetName,
                version: CONFIG.PRESET_VERSION,
                preset: cloneChoices()
            };

            if (presetId) {
                presetData.id = presetId;
            }

            confirmSavePreset(presetData).then(() => {
                storePreset(presetData, getPresetConfig(), !STATUS.isInline).then(preset => {
                    if (preset) {
                        if (presetData.id) {
                            setPresetName(preset.name);
                            STATUS.loadedPreset = preset;
                        } 
                        
                        if (STATUS.isInline) {
                            STATUS.viewDialog.close().then(() => {
                                ScoreTrekBattle.Event.trigger('preset.updated', preset);
                            });
                            return;
                        }

                        if (STATUS.returnType === 'return:tournament.details') {
                            if (STATUS.returnId) {
                                ScoreTrekBattle.View.goto(`/tournament/details/${STATUS.returnId}`);
                            } else {
                                ScoreTrekBattle.View.goto(`/tournament/plan`);
                            }
                            return;
                        }

                        if (STATUS.returnType === 'return:tournament.edit') {
                            if (STATUS.returnId) {
                                ScoreTrekBattle.View.goto(`/tournament/edit/${STATUS.returnId}/${preset.id}`);
                            } else {
                                ScoreTrekBattle.View.goto(`/tournament/create/${preset.id}`);
                            }
                            return;
                        }

                        ScoreTrekBattle.View.goto(`/tournament/preset/list/${preset.id}`);
                    }
                }).catch(ignore => {});
            }).catch(ignore => {});
        }).catch(ignore => {});
    }

    function confirmSavePreset(presetData) {
        return new Promise(function(resolve, reject) {
            if (SHOW_NOTICE.multiBallUpdate && (presetData.preset.gameType === 'gameMulti')) {
                chmDialog.confirm(__i18n('dialog/confirm/presetMultiballUpdate/text'), {
                    title: __i18n('dialog/confirm/presetMultiballUpdate/title'),
                    buttonYes: __i18n('button/confirm'),
                    buttonNo: __i18n('button/cancel')
                }).then(resolve).catch(reject);
                return;
            }

            resolve();
        });

    }

    function getPresetConfig() {
        return {
            // officialScheme: STATUS.view.controls.officialScheme.get()
        };
    }

    function validateGameMultiType(gameType, isRotation) {
        let config;

        config = isRotation ? CONFIG.ROTATION_GAMES : CONFIG.MULTIBALL_GAMES;

        if (config.indexOf(gameType) < 0) {
            return config[0];
        }

        return gameType;
    }

    function validatePreset() {
        if (!STATUS.active) {
            console.warn('action.tournamentPreset.save triggered while not active.');
            return false;
        }

        if (!STATUS.choices) {
            console.warn('action.tournamentPreset.save triggered with choices pending.');
            return false;
        }

        return true;
    }

    function storePreset(presetData, presetConfig, showConfirmation) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Preset.Edit.storePreset', true);
            Api.request(`/battle/tournament/preset/${presetData.hasOwnProperty('id') ? 'update' : 'create'}`, {
                preset: presetData,
                config: presetConfig
            }).then(result => {
                if (result && result.done) {
                    if (showConfirmation !== false) {
                        chmDialog.success(__i18n(`tournament/preset/${presetData.hasOwnProperty('id') ? 'update' : 'create'}/done`), null, __i18n('button/ok')).then(() => {
                            resolve(result.preset);
                        });
                    } else {
                        resolve(result.preset);
                    }
                } else {
                    chmDialog.error(`tournament/preset/${presetData.hasOwnProperty('id') ? 'update' : 'create'}/failed`);
                    reject();
                }
            }).catch(result => {
                let error;
                if (result.error && result.message) {
                    error = (result.message === 'PRESET_HAS_RUNNING_TOURNAMENT') ? _this.renderInUseError(presetData.id) : result;
                    chmDialog.error(error);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                AnimationHandler.scrollToTop(false, STATUS.$view);
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Preset.Edit.storePreset', false);
            });
        });
    }

    function editPresetName(currentPresetName) {
        return new Promise(function(resolve, reject) {
            chmDialog.prompt({
                title: __i18n('dialog/tournamentPreset/name/title'),
                prompt: __i18n('dialog/tournamentPreset/name/prompt'),
                value: currentPresetName
            }).then(presetName => {
                if (!presetName) {
                    reject();
                    return;
                }
                resolve(presetName);
            }).catch(reject);
        });
    }

    function showPresetTournaments(presetId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Preset.Edit.showPresetTournaments', true);
            Api.request('/battle/tournament/preset/tournaments', {id: presetId}).then(result => {
                if (result && result.preset && result.tournaments) {
                    showPresetTournamentsDialog(result.preset, result.tournaments);
                } else {
                    chmDialog.error(new Error('error/PRESET_DOES_NOT_EXIST'));
                }
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Preset.Edit.showPresetTournaments', false);
            });
        });
    }

    function showPresetTournamentsDialog(preset, tournaments) {
        ScoreTrekBattle.Tournament.List.renderList(tournaments, true).then($items => {
            if (!$items || ($items.length === 0)) {
                ScoreTrekBattle.Tournament.List.renderEmptyItem().then($item => {
                    $item.find('[data-id="emptyItemLinks"]').remove();
                    displayPresetTournamentsDialog(preset, [$item]);
                });
                return;
            }

            displayPresetTournamentsDialog(preset, $items);
        });
    }

    function displayPresetTournamentsDialog(preset, $items) {
        if (!$items || ($items.length === 0)) {
            return;
        }

        $items.forEach($item => {
            $item.find('[data-ref-id="default"],[data-ref-id="plan"],[data-id="toolbar"]').remove();
            $item.find('[data-list-href]').each(function() {
                this.href = this.dataset.listHref;
            });
        });

        chmDialog({
            content: $('<div>').addClass('preset-tournaments-list').append($items),
            title: `<i class="color-blue"><i class="fa-solid fa-sliders"></i></i> <span class="color-yellow">${__escapeHTML(preset.name)}</span><span class="text-white-50"> – ${__i18n('tournament/multi')}</span>`,
            large: true
        });
    }

    function deletePreset(presetId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Preset.Edit.deletePreset', true);
            Api.request('/battle/tournament/preset/delete', {id: presetId}).then(result => {
                resolve();
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Preset.Edit.deletePreset', false);
            });
        });
    }

    function clonePreset(presetId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Preset.Edit.clonePreset', true);
            Api.request('/battle/tournament/preset/clone', {id: presetId}).then(result => {
                resolve(result.presetId);
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Preset.Edit.clonePreset', false);
            });
        });
    }

    function makePresetOfficial(presetId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Preset.Edit.makePresetOfficial', true);
            Api.request('/battle/tournament/preset/makeOfficial', {id: presetId}).then(result => {
                resolve(result.presetId);
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Preset.Edit.makePresetOfficial', false);
            });
        });
    }

    _this = {
        autoUpdate: function(preset) {
            autoUpdatePresetVersion(preset);
        },
        allowAlternatingBreak(gameType) {
            return allowAlternatingBreak(gameType);
        },
        allowTakeLimit(gameType) {
            return allowTakeLimit(gameType);
        },
        clone: function(presetId) {
            return clonePreset(presetId);
        },
        delete: function(presetId) {
            return deletePreset(presetId);
        },
        rename: function(presetId, currentPresetName) {
            return new Promise(function(resolve, reject) {
                editPresetName(currentPresetName).then(presetName => {
                    storePreset({
                        id: presetId,
                        name: presetName
                    }, null, false).then(preset => {
                        resolve(preset);
                    }).catch(reject);
                }).catch(reject);
            });
        },
        renderInUseError: function(presetId) {
            return `${__i18n(`error/PRESET_IN_USE`)}<br>&nbsp;<br><a href="javascript:" data-trigger-action="preset.listTournaments" data-preset-id="${presetId}" title="${__i18n('button/listTournamentsWithPreset')}"><i class="fa-solid fa-calendar-day"></i> <span>${__i18n('button/showTournaments')}</span> <span class="text-smaller"><i class="fa-solid fa-chevron-right"></i></span></a>`;
        }
    };

    ScoreTrekBattle.View.register('/tournament/preset/create', onViewRenderCreate, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess, onInline);
    ScoreTrekBattle.View.register('/tournament/preset/edit', onViewRenderEdit, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess, onInline);

    ScoreTrekBattle.Event.on('action.tournamentPreset.save', function() {
        savePreset(STATUS.loadedPreset ? STATUS.loadedPreset.id : null);
    });

    ScoreTrekBattle.Event.on('action.preset.editName', function() {
        var $preset, presetId, currentPresetName;
        $preset = $(this).closest('[data-preset-id]');
        presetId = $preset.attr('data-preset-id');
        currentPresetName = $preset.find('[data-id="preset.name"]').text();
        _this.rename(presetId, currentPresetName).then(preset => {
            if (preset) {
                ['name', 'modified'].forEach(fieldName => {
                    $preset.find(`[data-id="preset.${fieldName}"]`).text(preset[fieldName]);
                });
                AnimationHandler.scrollIntoView($preset).then(() => {
                    AnimationHandler.pulse($preset);
                });
            }
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.preset.rename', function() {
        if (!STATUS.active) {
            return;
        }

        if (STATUS.isUsedRunning) {
            _this.rename(STATUS.loadedPreset.id, getPresetName()).then(preset => {
                setPresetName(preset.name);
                ScoreTrekBattle.Event.trigger('preset.updated', preset);                
            });

            return;
        }

        editPresetName(getPresetName()).then(presetName => {
            setPresetName(presetName);
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.preset.listTournaments', function() {
        var $preset, presetId;
        $preset = $(this).closest('[data-preset-id]');
        presetId = $preset.attr('data-preset-id');
        showPresetTournaments(presetId);
    });

    ScoreTrekBattle.Event.on('action.preset.clone', function() {
        var $preset, presetId, presetName;
        $preset = $(this).closest('[data-preset-id]');
        presetId = $preset.attr('data-preset-id');
        presetName = $preset.find('[data-id="preset.name"]').text();
        _this.clone
        chmDialog.confirm(__i18n('dialog/confirm/clone/text', {colorClass: 'color-yellow', reference: presetName}, true), {
            title: __i18n('dialog/confirm/clone/title'),
            buttonYes: __i18n('button/clone'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            clonePreset(presetId).then(newPresetId => {
                ScoreTrekBattle.View.refresh(newPresetId);
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.preset.delete', function() {
        var $preset, presetId, presetName;
        $preset = $(this).closest('[data-preset-id]');
        presetId = $preset.attr('data-preset-id');
        presetName = $preset.find('[data-id="preset.name"]').text();
        chmDialog.confirm(__i18n('dialog/confirm/delete/text', {colorClass: 'color-yellow', reference: presetName}, true), {
            title: __i18n('dialog/confirm/delete/title'),
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            deletePreset(presetId).then(() => {
                $preset.slideUp(() => {
                    $preset.remove();
                });
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.preset.makeOfficial', function() {
        var $preset, presetId, presetName;
        $preset = $(this).closest('[data-preset-id]');
        presetId = $preset.attr('data-preset-id');
        presetName = $preset.find('[data-id="preset.name"]').text();
        chmDialog.confirm(__i18n('dialog/confirm/makePresetOfficial/text', {reference: presetName}, true), {
            title: __i18n('dialog/confirm/makePresetOfficial/title'),
            buttonYes: __i18n('button/confirm'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            makePresetOfficial(presetId).then(newPresetId => {
                ScoreTrekBattle.View.goto(`/tournament/preset/list/official/${newPresetId}`);
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    return _this;
})();